export default "__VITE_ASSET__BZ85ik5z__"